import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildRoomEntityV2 } from "@youm-front/room/util/factory";
import {
  ROOMS_PAST_LIST_FEATURE_KEY,
  RoomsPastListState,
  roomsPastListAdapter
} from "../reducers";

const { selectAll } = roomsPastListAdapter.getSelectors();

const state = createFeatureSelector<RoomsPastListState>(
  ROOMS_PAST_LIST_FEATURE_KEY
);

export const isLoading = createSelector(
  state,
  (state: RoomsPastListState) => state.isLoading
);

export const rooms = createSelector(state, (state: RoomsPastListState) =>
  selectAll(state).map((_) => buildRoomEntityV2(_))
);
